import React, { useEffect, useState } from "react";
import { CardContainer } from "../../components/Card/CardContainer";
import TablePagination from "../../components/Table/TablePagination";
import { icon } from "../../resource";
import Text from "../../components/Text/Text";
import { Col, Row, Switch, Tabs } from "antd";
import { SearchOutlined, UnorderedListOutlined } from "@ant-design/icons";
import { RangePicker } from "../../components/DatePicker/DatePicker";
import Button from "../../components/Button/Button";
import Input from "../../components/Input/Input";
import { FlexCol } from "../../components/Container/Container";
import StatusBadge from "../../components/Badge/StatusBadge";
import { MAP_STATUS_TOUR, MAP_STATUS_WORD_TOUR } from "../../definitions/achievementStatus";
import Permission from "../../components/Permission/Permission";
import { ActionBtn } from "../../components/Button/TableActionButton";
import { useLocation, useNavigate } from "react-router-dom";
import {
  createStep1,
  deleteAchievement,
  getAchievement,
  updateStatusAchievement,
} from "../../datasource/AchievementDataSource";
import {
  AchievementEntity_INIT,
  StatusEntity_INIT,
  type AchievementEntity,
  type StatusEntity,
} from "../../entities/AchievementEntity";
import { dateFormatter, numberFormatter } from "../../utility/Formatter";
import { ModalConfirm, ModalConfirmType } from "../../components/Modal/Confirm";

function IndexAchievement() {
  const navigate = useNavigate();
  const [page, setPage] = useState(1);
  const [data, setData] = useState<{
    count: number;
    data: AchievementEntity[];
    statusCount: StatusEntity;
  }>({
    count: 0,
    data: [AchievementEntity_INIT],
    statusCount: StatusEntity_INIT,
  });
  const userProfile = JSON.parse(localStorage.getItem("profile")!);
  const take = 10;
  const [searchText, setSearchText] = useState<string | undefined>(undefined);
  const [status, setStatus] = useState<string>("ALL");
  const [loading, setLoading] = useState(false);
  const [dateFilter, setDateFilter] = useState<any>();
  const { company, firstname, lastname } = userProfile;
  const [modalDelete, setModalDelete] = useState<{ open: boolean; id: string }>({
    open: false,
    id: "",
  });
  const [activeAchieve, setActiveAchieve] = useState<{ open: boolean; id: string; check: string }>({
    open: false,
    id: "",
    check: "",
  });
  useEffect(() => {
    const clearTabs = () => localStorage.removeItem("tabDetailTour");
    const interval = 2 * 1000;
    const id = setInterval(clearTabs, interval);
    return () => clearInterval(id);
  }, []);

  const fetchData = async () => {
    setLoading(true);
    try {
      await getAchievement({
        company,
        page,
        take,
        searchText,
        status,
        startDate: dateFilter && dateFilter[0] ? dateFilter[0].format("YYYY-MM-DD") : undefined,
        endDate: dateFilter && dateFilter[1] ? dateFilter[1].format("YYYY-MM-DD") : undefined,
      }).then((res) => {
        setData(res);
      });
    } catch (error) {
      console.log("err get achievement list", error);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchData();
  }, [status, searchText, page, dateFilter]);

  const PageTitle = () => {
    return (
      <Row align='middle' justify='space-between'>
        <Col className='gutter-row' span={12}>
          <div>
            <span
              className='card-label font-weight-bolder text-dark'
              style={{ fontSize: 20, fontWeight: "bold" }}
            >
              รายการความสำเร็จ (Achievement)
            </span>
          </div>
        </Col>
        <Col span={4}>
          <Input
            allowClear
            placeholder='ค้นหา'
            suffix={<SearchOutlined />}
            defaultValue={searchText}
            onPressEnter={(e) => {
              const value = (e.target as HTMLTextAreaElement).value;
              setSearchText(value);
              setPage(1);
            }}
            onChange={(e) => {
              const value = (e.target as HTMLInputElement).value;
              if (!value) {
                setSearchText("");
              }
            }}
          />
        </Col>
        <Col span={4}>
          <RangePicker
            allowEmpty={[true, true]}
            enablePast
            value={dateFilter}
            onChange={(dates, dateString) => {
              setDateFilter(dates);
              setPage(1);
            }}
          />
        </Col>
        <Col span={3}>
          <Button
            type='primary'
            title='+ สร้างความสำเร็จ'
            height={40}
            size='large'
            onClick={() => navigate("create/0/list")}
          />
        </Col>
      </Row>
    );
  };
  const tabsItems = [
    {
      label: (
        <Text fontSize={14}>{`ทั้งหมด (${numberFormatter(data.statusCount?.ALL || 0, 0)})`}</Text>
      ),
      key: "ALL",
    },
    {
      label: (
        <Text fontSize={14}>{`รออนุมัติ (${numberFormatter(
          data.statusCount?.WAIT_APPROVE || 0,
          0,
        )})`}</Text>
      ),
      key: "WAIT_APPROVE",
    },
    {
      label: (
        <Text fontSize={14}>{`รอเริ่ม (${numberFormatter(
          data.statusCount?.PENDING || 0,
          0,
        )})`}</Text>
      ),
      key: "PENDING",
    },
    {
      label: (
        <Text fontSize={14}>{`เปิดใช้งาน (${numberFormatter(
          data.statusCount?.ACTIVE || 0,
          0,
        )})`}</Text>
      ),
      key: "ACTIVE",
    },
    {
      label: (
        <Text fontSize={14}>{`ปิดใช้งาน (${numberFormatter(
          data.statusCount?.INACTIVE || 0,
          0,
        )})`}</Text>
      ),
      key: "INACTIVE",
    },
    {
      label: (
        <Text fontSize={14}>{`หมดอายุ (${numberFormatter(
          data.statusCount?.EXPIRE || 0,
          0,
        )})`}</Text>
      ),
      key: "EXPIRE",
    },
  ];
  const columns: any = [
    {
      title: "ชื่อความสำเร็จ",
      dataIndex: "achievementName",
      key: "achievementName",
      render: (value: any, row: any, index: number) => {
        return {
          children: (
            <FlexCol>
              <Text fontFamily='Sarabun'>{value}</Text>
              <Text level={6} color='Text3' fontFamily='Sarabun'>
                {row.achievementCode}
              </Text>
            </FlexCol>
          ),
        };
      },
    },
    {
      title: "ระยะเวลา",
      dataIndex: "time",
      key: "time",
      render: (value: any, row: any, index: number) => {
        return {
          children: (
            <FlexCol>
              <Text fontFamily='Sarabun'>
                {dateFormatter(row.startDate)} - {dateFormatter(row.endDate)}
              </Text>
            </FlexCol>
          ),
        };
      },
    },
    {
      title: "ระดับสะสม",
      dataIndex: "achievementMainRewardCount",
      key: "achievementMainRewardCount",
      render: (value: any, row: any, index: number) => {
        return {
          children: (
            <FlexCol>
              <Text>{numberFormatter(value, 0)}</Text>
              <Text level={6} color='Text3' fontFamily='Sarabun'>
                ระดับสะสม
              </Text>
            </FlexCol>
          ),
        };
      },
    },
    {
      title: "รางวัลพิเศษ",
      dataIndex: "achievementSpecialRewardCount",
      key: "achievementSpecialRewardCount",
      render: (value: any, row: any, index: number) => {
        return {
          children: (
            <FlexCol>
              <Text>{row.isSpecial ? numberFormatter(value, 0) : 0}</Text>
              <Text level={6} color='Text3' fontFamily='Sarabun'>
                รางวัลพิเศษ
              </Text>
            </FlexCol>
          ),
        };
      },
    },
    {
      title: "อัปเดตโดย",
      dataIndex: "updatedAt",
      key: "updatedAt",
      render: (value: any, row: any, index: number) => {
        return {
          children: (
            <FlexCol>
              <Text>{dateFormatter(value)}</Text>
              <Text level={6} color='Text3' fontFamily='Sarabun'>
                {row.updatedBy}
              </Text>
            </FlexCol>
          ),
        };
      },
    },
    {
      title: "สถานะ",
      dataIndex: "thisStatus",
      key: "thisStatus",
      render: (value: any, row: any, index: number) => {
        return {
          children:
            value === "EXPIRE" ? (
              <Text fontSize={14} color='Disable'>
                หมดอายุ
              </Text>
            ) : (
              <StatusBadge
                borderRadius='8px'
                label={MAP_STATUS_WORD_TOUR[value]}
                bgColor={MAP_STATUS_TOUR[value]}
              />
            ),
        };
      },
    },
    {
      title: "เปิด/ปิด",
      dataIndex: "status",
      key: "status",
      render: (value: any, row: any, index: number) => {
        let checked = false;
        checked = ["PENDING", "ACTIVE"].includes(row.thisStatus) ? true : false;
        return {
          children: (
            <Switch
              checked={checked}
              onClick={() => {
                setActiveAchieve({
                  open: true,
                  id: row.achievementId,
                  check: checked ? "INACTIVE" : "ACTIVE",
                });
              }}
              disabled={["EXPIRE", "WAIT_APPROVE"].includes(row.thisStatus)}
            />
          ),
        };
      },
    },
    {
      title: "จัดการ",
      dataIndex: "action",
      key: "action",
      render: (value: any, row: any, index: number) => {
        const disabled = !["WAIT_APPROVE", "PENDING"].includes(row.thisStatus);
        const checkDelete = row.thisStatus === "INACTIVE" && !row.notDelete;
        return {
          children: (
            <Row gutter={10} style={{ gap: 6 }} justify='start'>
              <Permission permission={["achievement", "view"]}>
                <ActionBtn
                  onClick={() =>
                    navigate("/crm/achievement/" + row.achievementId, {
                      state: {
                        status: row.thisStatus,
                      },
                    })
                  }
                  icon={
                    <UnorderedListOutlined style={{ width: 16, height: 16, fontWeight: 700 }} />
                  }
                />
              </Permission>
              <Permission permission={["achievement", "delete"]}>
                <ActionBtn
                  disabled={disabled && !checkDelete}
                  onClick={() => {
                    setModalDelete({
                      open: disabled && !checkDelete ? false : true,
                      id: row.achievementId,
                    });
                  }}
                  icon={
                    <img
                      src={disabled && !checkDelete ? icon.deleteText4 : icon.delete}
                      style={{ width: 16, height: 16 }}
                    />
                  }
                />
              </Permission>
            </Row>
          ),
        };
      },
    },
  ];

  return (
    <CardContainer>
      <PageTitle />
      <br />
      <Tabs
        items={tabsItems}
        onChange={(key: string) => {
          setStatus(key);
          setPage(1);
        }}
        defaultValue={"ALL"}
      />
      <TablePagination
        columns={columns}
        data={data.data}
        isLoading={loading}
        locale={{
          emptyText: (
            <div
              style={{
                padding: 32,
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                gap: 24,
                minHeight: 350,
              }}
            >
              <img
                src={icon.emptyHistoryPoint}
                style={{
                  width: 80,
                  height: 90,
                }}
                alt='empty_table'
              />
              <Text fontFamily='Sarabun' fontSize={14} fontWeight={400} color='Text3'>
                ไม่มีรายการความสำเร็จ
              </Text>
            </div>
          ),
        }}
        scroll={{ x: "max-content" }}
        pagination={{
          current: page,
          total: data.count,
          pageSize: 10,
        }}
        onPageChange={(pageNum) => setPage(pageNum)}
      />
      <ModalConfirm
        title='ต้องการปิดใช้งานความสำเร็จหรือไม่?'
        description='กรุณากด “ยกเลิก” ถ้าท่านไม่ต้องการปิดใช้งาน หรือ กด “ยืนยัน” ถ้าท่านต้องการปิดใช้งานความสำเร็จนี้'
        open={activeAchieve.open}
        toggleOpen={() => setActiveAchieve({ open: false, id: "", check: "" })}
        type={ModalConfirmType.CF}
        onOk={async () => {
          try {
            await updateStatusAchievement({
              achievementId: activeAchieve.id,
              status: activeAchieve.check,
              updatedBy: firstname + " " + lastname,
            }).then(() => {
              fetchData();
              setActiveAchieve({ open: false, id: "", check: "" });
            });
          } catch (error) {
            console.log("error active achievement", error);
          }
        }}
      />

      <ModalConfirm
        title='ยืนยันการลบรายการความสำเร็จ'
        description='โปรดตรวจสอบรายละเอียดก่อนกดยืนยัน'
        open={modalDelete.open}
        toggleOpen={() => setModalDelete({ open: false, id: "" })}
        type={ModalConfirmType.DEL}
        onOk={async () => {
          try {
            await deleteAchievement(modalDelete.id).then(() => {
              setModalDelete({ open: false, id: "" });
              fetchData();
            });
          } catch (error) {
            console.log("error delete achievement", error);
          }
        }}
      />
    </CardContainer>
  );
}

export default IndexAchievement;
